import { render, staticRenderFns } from "./transformOrder.vue?vue&type=template&id=86931000&scoped=true"
import script from "./transformOrder.vue?vue&type=script&lang=js"
export * from "./transformOrder.vue?vue&type=script&lang=js"
import style0 from "./transformOrder.vue?vue&type=style&index=0&id=86931000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86931000",
  null
  
)

export default component.exports